module.exports = __webpack_public_path__ + "static/media/globe.0ac634fc.png";